import { t, tn } from '../../../lib/i18n';
import type { Change } from './diff';

export { diffDrafts } from './diff';
export type { Change } from './diff';

export function DiffView({ changes }: { changes: Change[] }) {
  if (changes.length === 0) {
    return <p className="text-sm text-[var(--color-muted)]">{t('Identisch mit der aktuell veröffentlichten Fassung.')}</p>;
  }
  const material = changes.filter((c) => c.material).length;
  return (
    <div className="space-y-3">
      {material > 0 && (
        <div className="rounded-lg bg-[var(--color-note)] p-3 text-xs text-[var(--color-note-ink)]">
          <strong>{tn('{n} inhaltliche Änderung.', '{n} inhaltliche Änderungen.', material)}</strong>{' '}
          {t('Damit ändert sich der Nachweis-Hash, und alle Besucher mit bestehender Einwilligung werden erneut gefragt.')}
        </div>
      )}
      {/* One change per block, not per row.
          Three columns with `truncate` fitted a colour code and nothing else: a list of
          legal links or a font stack was cut at the column edge, and the before value —
          struck through, next to an arrow — was the half that got cut first. Struck-out
          text is hard enough to read when it is whole. So each change gets its name, then
          both values under it, labelled and wrapping. */}
      <ul className="max-h-72 divide-y divide-[var(--color-line)] overflow-auto text-xs">
        {changes.map((c) => (
          <li key={`${c.path}|${c.after}`} className="py-2">
            <div className="font-medium">
              {c.material && <span title={t('Ändert den Nachweis')} className="mr-1">●</span>}
              {c.path}
            </div>
            <div className="mt-1 grid grid-cols-[auto_1fr] gap-x-2 gap-y-0.5">
              <span className="text-[var(--color-muted)]">{t('vorher')}</span>
              <span className="break-words text-[var(--color-muted)]">{c.before}</span>
              <span className="text-[var(--color-muted)]">{t('neu')}</span>
              <span className="break-words font-medium">{c.after}</span>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
